<template>
  <div id="atencao">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Atenção"
            description=""
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao=""
            pageIdentifier="atencao"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros
            :cadastros="cadastros"
            :loading="loading"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import TabelaCadastros from './TabelaCadastros.vue'
import SectionTitle from '@/components/SectionTitle'

export default {
  metaInfo: {
    title: 'Atenção',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    TabelaCadastros,
    SectionTitle,
  },
  computed: {},
  data() {
    return {
      cadastros: [],
      loading: false,
    }
  },
  mounted() {
    this.buscarDados()
  },
  methods: {
    /**
     * Buscar dados
     */
    async buscarDados() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/atencao/' + this.$store.state.cod_ibge
        )
        if (response) {
          this.cadastros = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
